module.exports = __webpack_public_path__ + "static/Cherry-Blossom-56e1bc2b3bd685c26461978dae135fe3.png";